import config from 'src/config'
import helpers from 'src/helpers'

function load(component) {
  return () => import(`src/${component}.vue`)
}

let path = name => helpers.makeStringConcatenation('modules.report', name)

const MODULE_PATH = '/reports/'

export default [
  {
    path: MODULE_PATH,
    component: load('containers/Full'),
    name: 'Reports',
    meta: {
      title: path('reports.title'),
      menuItem: true,
      sorting: config.sidebar.menu.sorting.modules.reports,
      icon: 'bar_chart',
    },
    children: [
      {
        path: MODULE_PATH + 'emails/list',
        component: load('application/reports/components/EmailReportList'),
        name: 'Email Report List',
        meta: {
          title: path('emailReportList.title'),
          icon: 'report',
          menuItem: true,
          sorting: 4001,
        },
      },
      {
        path: MODULE_PATH + 'invoices/summary',
        component: load('application/reports/components/TaxInvoiceSummaryReport'),
        name: 'Tax Invoice Summary List',
        meta: {
          title: path('taxInvoiceSummaryList.title'),
          icon: 'report',
          menuItem: true,
          sorting: 4002,
        },
      },
      {
        path: MODULE_PATH + 'invoices/product',
        component: load('application/reports/components/TaxInvoiceByProductDetailReport'),
        name: 'Tax Invoice By Product Detail Report',
        meta: {
          title: path('taxInvoiceByProductDetailReport.title'),
          icon: 'report',
          menuItem: true,
          sorting: 4003,
        },
      },
      {
        path: MODULE_PATH + 'product/sales',
        component: load('application/reports/components/ProductSalesReport'),
        name: 'Product Sales Report',
        meta: {
          title: path('productSalesReport.title'),
          icon: 'report',
          menuItem: true,
          sorting: 4004,
        },
      },
      {
        path: MODULE_PATH + 'cv/allocations',
        component: load('application/reports/components/CvAllocationReport'),
        name: 'CV Allocation Report',
        meta: {
          title: path('cvAllocationReport.title'),
          icon: 'report',
          menuItem: true,
          sorting: 4005,
        },
      },
      {
        path: MODULE_PATH + 'cw/wb/detail',
        component: load('application/reports/components/CwWbDetailReport'),
        name: 'CW WB Details Report',
        meta: {
          title: path('cwWbDetailsReport.title'),
          icon: 'report',
          menuItem: true,
          sorting: 4006,
        },
      },
      {
        path: MODULE_PATH + 'ewallet/list',
        component: load('application/reports/components/EwalletReports'),
        name: 'E-wallet Reports',
        meta: {
          title: path('eWalletReports.title'),
          icon: 'report',
          menuItem: true,
          sorting: 4007,
        },
      },
      {
        path: MODULE_PATH + 'ewallet/individual',
        component: load('application/reports/components/EwalletIndividualReport'),
        name: 'E-wallet Individual Report',
        meta: {
          title: path('eWalletIndividualReports.title'),
          icon: 'report',
          menuItem: true,
          sorting: 4008,
        },
      },
      {
        path: MODULE_PATH + 'stockist/commission',
        component: load('application/reports/components/StockistCommissionReport'),
        name: 'Stockist Commission Report',
        meta: {
          title: path('stockistCommissionReport.title'),
          icon: 'report',
          menuItem: true,
          sorting: 4009,
        },
      },
      {
        path: MODULE_PATH + 'taiwan/purchase',
        component: load('application/reports/components/TaiwanPurchaseReport'),
        name: 'Taiwan Purchase Report',
        meta: {
          title: path('taiwanPurchaseReport.title'),
          icon: 'report',
          menuItem: true,
          sorting: 4010,
        },
      },
      {
        path: MODULE_PATH + 'bv/sv/info/view',
        component: load('application/reports/components/MemberBvSvInfo'),
        name: 'Members BV/SV Info',
        meta: {
          title: path('memberBvSvInfo.title'),
          icon: 'report',
          menuItem: true,
          sorting: 4011,
        },
      },
      {
        path: MODULE_PATH + 'visitor/history',
        component: load('application/reports/components/VisitorHistoryList'),
        name: 'Visitor History List',
        props: true,
        meta: {
          title: path('visitorHistoryList.title'),
          icon: 'report',
          menuItem: true,
          sorting: 4012,
        },
      },
    ],
  },
]
